import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { IRiskEditItem, RiskEditItem } from "./riskEditItem";
import { IRiskEditUnitChange, RiskEditUnitChange } from "./riskEditUnitChange";

export interface IRiskEdit extends IRiskEditUnitChange {
    item: IRiskEditItem;
    units: IIdTitleNode[];
    riskCategories: IIdTitleNode[];
    riskProcesses: IIdTitleNode[];
    riskStandards: IIdTitleNode[];
    riskStakeholders: IIdTitleNode[];
    riskRiskProcessIds: string[];
    riskRiskStandardIds: string[];
    riskRiskStakeholderIds: string[];
    riskProcessName: string;
}

export class RiskEdit extends RiskEditUnitChange implements IRiskEdit {
    item: RiskEditItem;
    units: IdTitleNode[];
    riskCategories: IdTitleNode[];
    riskProcesses: IdTitleNode[];
    riskStandards: IdTitleNode[];
    riskStakeholders: IdTitleNode[];
    riskRiskProcessIds: string[];
    riskRiskStandardIds: string[];
    riskRiskStakeholderIds: string[];
    riskProcessName: string;

    constructor();
    constructor(obj: IRiskEdit);
    constructor(obj?: any) {
        super(obj);
        this.item = new RiskEditItem(obj?.item);
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.riskCategories = Base.getTypedArray(obj?.riskCategories, IdTitleNode);
        this.riskProcesses = Base.getTypedArray(obj?.riskProcesses, IdTitleNode);
        this.riskStandards = Base.getTypedArray(obj?.riskStandards, IdTitleNode);
        this.riskStakeholders = Base.getTypedArray(obj?.riskStakeholders, IdTitleNode);
        this.riskRiskProcessIds = obj.riskRiskProcessIds || [];
        this.riskRiskStandardIds = obj.riskRiskStandardIds || [];
        this.riskRiskStakeholderIds = obj.riskRiskStakeholderIds || [];
        this.riskProcessName = obj.riskProcessName || "";
    }
}